// One unified design for every company — per-tenant theme/background overrides are retired.
function applyTheme() {
    const root = document.documentElement;
    ["--theme-primary", "--theme-primary-500", "--theme-primary-700", "--theme-accent", "--theme-background"].forEach((v) => root.style.removeProperty(v));
    root.classList.remove("theme-dark");
    document.body.style.backgroundImage = "";
    document.body.style.backgroundColor = "";
}

export default function ThemeProvider({ children }) {
    applyTheme();
    return children;
}

export { applyTheme };
